import React from "react";

import { useRouteError } from "react-router-dom";
import { ReactComponent as ErrorGeneral } from "../../assets/images/empty-state/empty-general.svg";
import { ErrorLayout } from "../../components/layouts/ErrorLayout";
import { getErrorMessageFromError } from "../../utils/errors";

export const InboxError = () => {
  const error: any = useRouteError();
  const message = getErrorMessageFromError(error);

  return (
    <ErrorLayout
      overallTitle="Inbox"
      title="An error occurred while loading the Inbox."
      subTitle={message}
    >
      <ErrorGeneral />
    </ErrorLayout>
  );
};
